import { useCallback } from 'react';
import { openWindow } from '@umu/umu-dom';

/**
 * SVG 链接事件监听 Hook
 * 功能：为 SVG 元素绑定链接点击事件
 */
interface IUseSvgLinkEventsInfo {
    url: string;
    linkType: string;
    element?: SVGElement;
}
interface IUseSvgLinkEventsData {
    allowOpenWindow?: boolean;
    onLinkClick?: (info: IUseSvgLinkEventsInfo) => void;
}
export const useSvgLinkEvents = (data: IUseSvgLinkEventsData) => {
    const { allowOpenWindow = true, onLinkClick } = data;
    // 链接点击处理函数
    const handleLinkClick = useCallback(
        (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            const target = e.target as SVGElement;
            const url = target.getAttribute('data-link');
            const linkType = target.getAttribute('data-link-type') || '';

            if (!url) {
                return;
            }
            // 如果状态为 NO，不允许点击跳转
            if (!allowOpenWindow) {
                return;
            }

            // 默认跳转逻辑
            if (url.startsWith('http://') || url.startsWith('https://')) {
                onLinkClick ? onLinkClick({ url, linkType, element: target }) : openWindow(url, '_blank');
            }
        },
        [allowOpenWindow],
    );

    // 绑定链接事件
    const bindLinkEvents = useCallback(
        (svgContainer: HTMLElement) => {
            if (!svgContainer) {
                return;
            }

            // 移除旧的事件监听器
            const existingLinks = svgContainer.querySelectorAll('[data-link]');
            existingLinks.forEach((element) => {
                element.removeEventListener('click', handleLinkClick);
            });

            // 添加新的事件监听器
            const linkElements = svgContainer.querySelectorAll('[data-link]');
            linkElements.forEach((element) => {
                element.addEventListener('click', handleLinkClick);
            });
        },
        [handleLinkClick],
    );

    return {
        handleLinkClick,
        bindLinkEvents,
    };
};
